// extracted by mini-css-extract-plugin
export default {"primary":"#ff5722","borderColor":"#979ba0","primaryText":"#303841"};